import { render, staticRenderFns } from "./IconIntentRelationship.vue?vue&type=template&id=084a4887&"
import script from "./IconIntentRelationship.vue?vue&type=script&lang=js&"
export * from "./IconIntentRelationship.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports